import classNames from "classnames";
import React from "react";
import styles from "./SitePageIntro.scss";

/**
 * Heading at the top of a public page: eyebrow, h1 title and lead.
 * For headings of sections further down a page, use SiteSectionIntro.
 * @param eyebrow – small label above the title; any content (e.g. icon + text)
 * @param align – "left" (default) or "center"
 * @param children – extras below the lead, e.g. buttons or a "Last updated" line
 */
export const SitePageIntro = ({ eyebrow, title, lead, align = "left", className, children }) => {
    return (
        <div className={classNames(styles.base, { [styles.alignCenter]: align === "center" }, className)}>
            {eyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
            <h1 className={styles.title}>{title}</h1>
            {lead ? <p className={styles.lead}>{lead}</p> : null}
            {children}
        </div>
    );
};
